/* unplugin-vue-components disabled */import { render } from "./statement_account_detail.vue?vue&type=template&id=0d98b214&scoped=true"
import script from "./statement_account_detail.vue?vue&type=script&lang=js"
export * from "./statement_account_detail.vue?vue&type=script&lang=js"

import "./statement_account_detail.vue?vue&type=style&index=0&id=0d98b214&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d98b214"]])

export default __exports__